/**
 * @generated SignedSource<<8edc93c2749ff7d427355286bee8a705>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
export type AddUserInput = {
  displayName?: string | null | undefined;
  email: string;
  name: string;
  roles: ReadonlyArray<string>;
  ssoUser?: boolean | null | undefined;
  username?: string | null | undefined;
};
export type AddUserMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddUserInput;
};
export type AddUserMutation$data = {
  readonly addUser: {
    readonly user: {
      readonly email: string | null | undefined;
      readonly id: string;
      readonly key: number;
      readonly name: string | null | undefined;
      readonly roleAssignmentPrincipal: any;
      readonly roleAssignments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly role: {
              readonly id: string;
              readonly name: string;
              readonly permissions: ReadonlyArray<Permission>;
            };
            readonly target: {
              readonly __typename: string;
              readonly displayName?: string;
              readonly id?: string;
              readonly name?: string;
              readonly roleAssignmentTarget: any;
            };
          };
        }> | null | undefined;
      };
      readonly username: string | null | undefined;
    };
  } | null | undefined;
};
export type AddUserMutation = {
  response: AddUserMutation$data;
  variables: AddUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v4/*:: as any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleAssignmentPrincipal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "RoleAssignmentConnection",
      "kind": "LinkedField",
      "name": "roleAssignments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleAssignmentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleAssignment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": [
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "permissions",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "target",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "roleAssignmentTarget",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        }
                      ],
                      "type": "RoleScope",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v5/*:: as any*/),
                      "type": "AccountGroup",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v5/*:: as any*/),
                      "type": "PolicyCollection",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v5/*:: as any*/),
                      "type": "RepositoryConfig",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v3/*:: as any*/)
                      ],
                      "type": "Node",
                      "abstractKey": "__isNode"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roleAssignments(first:100)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "addUser",
        "plural": false,
        "selections": [
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AddUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "addUser",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "user",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "UserEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bb4b81ff6a08e95c44cfc21e10bf0a5",
    "id": null,
    "metadata": {},
    "name": "AddUserMutation",
    "operationKind": "mutation",
    "text": "mutation AddUserMutation(\n  $input: AddUserInput!\n) {\n  addUser(input: $input) {\n    user {\n      email\n      id\n      key\n      name\n      roleAssignmentPrincipal\n      roleAssignments(first: 100) {\n        edges {\n          node {\n            id\n            role {\n              id\n              name\n              permissions\n            }\n            target {\n              __typename\n              roleAssignmentTarget\n              ... on RoleScope {\n                displayName\n              }\n              ... on AccountGroup {\n                name\n              }\n              ... on PolicyCollection {\n                name\n              }\n              ... on RepositoryConfig {\n                name\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n          }\n        }\n      }\n      username\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6a311ec6d5f53a173460677c15c7210";

export default node;
